import * as React from "react";
import { connect } from "react-redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { selectOutskirtBuildingCurrentLevel } from "../../selectors/selectOutskirtBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { Improvement } from "../improvement/Improvement";
import { ButtonMarketImprovementFulfillContracts } from "./ButtonMarketImprovementFulfillContracts";
var _DetailViewMarketImprovement = function (_a) {
    var item = _a.item, marketStage = _a.marketStage;
    if (!item) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }
    return (React.createElement(Improvement, { item: item, buildingStage: marketStage, buildingId: IdOutskirtBuildings.Market, lockedLevelButton: React.createElement(ButtonMarketImprovementFulfillContracts, null), lockedLevelText: IdLoca.market_requiredMarketLevel }));
};
var mapState = function (state) { return ({
    marketStage: selectOutskirtBuildingCurrentLevel(state, IdOutskirtBuildings.Market),
}); };
export var DetailViewMarketImprovement = connect(mapState)(_DetailViewMarketImprovement);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/DetailViewMarketImprovement.tsx
// module id = 2706
// module chunks = 3